import type { LocalViewpoint } from '@viewer/lib/viewpointsStore'

/** Pasta virtual dos viewpoints importados de BCF sem pasta. */
export const PASTA_IMPORTADOS = '__importados_bcf__'

/** A partir de quantos viewpoints um grupo abre dobrado. */
export const GRUPO_GRANDE = 50

/** O viewpoint conta para o modelo activo? Os importados de BCF não têm
 *  modelo (`primaryHash` vazio) e contam para qualquer um. */
export function doModeloActivo(
  v: Pick<LocalViewpoint, 'primaryHash' | 'modelHashes'>,
  activeHash: string,
): boolean {
  if (!v.primaryHash) return true
  if (v.primaryHash === activeHash) return true
  return (v.modelHashes ?? []).includes(activeHash)
}
